import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import makananevent from '../../assets/makananevent.png'
import calendar from '../../assets/calendar-1.svg'
import { useNavigate } from "react-router-dom";
import pork from '../../assets/pork.svg'
import circleback from '../../assets/circleback.svg'
import location from '../../assets/pin-1.svg'
import { CSSTransition } from 'react-transition-group';
import eventimg from '../../assets/banner.png'
import spinner from '../../assets/spinner.gif'

export const PageDetailEvent = () => {

    const [detail, setDetail] = useState()
    const [loading, setLoading] = useState(true)
    const [showNavPopup, setShowNavPopup] = useState(false)
    const handleCloseAll = () => {
        setShowNavPopup(false)
    }
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail({gambar:eventimg,judul:"Thanksgiving",style:"American style featuring Turkey and Sides",serving:"Free standing",menu:[{nama:"Yaki gyoza",foto:makananevent,bahan:["pork"]},{nama:"Yaki gyoza", foto:makananevent,bahan:["pork"]}], sisa:10, total:20, tanggal:"24 Feb", jam:"18:00 - 20:00", tempat:"Hotel Santika, BSD City", harga:300, listEvent:[{tanggal:"24 Feb",jam:"18:00 - 20:00",sisa:10,max:20},{tanggal:"27 Feb",jam:"18:00 - 20:00",sisa:3,max:20}]})
        localStorage.setItem('nav', 'e')
    },[])
    const [standby, setstandby] = useState(true)
    const firstUpdate = useRef(true);
    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            setLoading(false)
        }
    },[detail])
    const history = useNavigate()

    

    const handleJoinNow = () => {
        setstandby(false)
        setTimeout(function() {
            history('/event/detailEvent/setSchedule')
        }, 500);
    }

    
    
    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={() => history(-1)} className='backmobile' alt="back" src={circleback}></img>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="PDEtrans">
                <div>
                    <div className='PDEheader mobile' style={{backgroundImage:`url(${detail.gambar})`}}></div>
                    <div className='PDEkontainer'>
                        <div className='PDEheader desktop' style={{backgroundImage:`url(${detail.gambar})`}}></div>
                        <div className='PDEkonten flex'>
                            <div className='PDEkontenkiri'>
                                <div className='PDEflex flex'>
                                    <div className='PDEflexkiri'>
                                        <p className='big bold white'>{detail.judul}</p>
                                        <p className='grey medium PDEstyle'>{detail.style}</p>
                                    </div>
                                    <div className='PDEflexkanan desktop'>
                                        <p className='small white'>Start from</p>
                                        <p className='small bold white' style={{marginTop:"4px"}}>IDR {detail.harga}/PAX</p>
                                    </div>
                                </div>
                                <div className='PDEline desktop'></div>
                                <p className='medium white PDEserving'>Serving style:<span className='bold'> {detail.serving}</span></p>
                                <div className='mobile PDEflexcon PDEmargin'>
                                    <div>
                                        <p className='small white'>Start from</p>
                                        <p className='small bold white' style={{marginTop:"4px"}}>IDR {detail.harga}/PAX</p>
                                    </div>
                                    <button onClick={() => handleJoinNow()} className='PDEbutton2 tiny bold mobile'>Join Now</button>
                                </div>
                                <div className='mobile PDEmargin'>
                                    <div className='PDEeventdate'>
                                        <p className='medium bold white'>Event date</p>
                                        <div className='PDEmargin2'>
                                            {
                                                detail.listEvent.map((post) => (
                                                    <div>
                                                        {
                                                            post===detail.listEvent[0]?
                                                            <div className='PDEmargin3'>
                                                                <div className='flex' style={{alignItems:"center"}}>
                                                                    <img alt='icon' src={calendar} className="PDEicon2"></img>
                                                                    <p className='small white'>{post.tanggal} &ensp; • &ensp;  {post.jam}</p>
                                                                </div>
                                                                <div className='PDEslot'>
                                                                    { post.sisa<=3 ? 
                                                                    <p className='small red bold'>{post.sisa} Seats left</p>
                                                                    :
                                                                    <p className='small white bold'>{post.sisa} Seats left</p>
                                                                    }
                                                                    <p className='small white'>from {post.max}</p>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div>
                                                            <div className='PDEline mobile'/>
                                                            <div className='PDEmargin3'>
                                                                <div className='flex' style={{alignItems:"center"}}>
                                                                    <img alt='icon' src={calendar} className="PDEicon2"></img>
                                                                    <p className='small white'>{post.tanggal} &ensp; • &ensp;  {post.jam}</p>
                                                                </div>
                                                                <div className='PDEslot'>
                                                                    { post.sisa<=3 ? 
                                                                    <p className='small red bold'>{post.sisa} Seats left</p>
                                                                    :
                                                                    <p className='small white bold'>{post.sisa} Seats left</p>
                                                                    }
                                                                    <p className='small white'>from {post.max}</p>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    
                                                ))
                                            }
                                        </div>
                                    </div>

                                    <div className='PDElocation PDEmargin2'>
                                        <p className='medium bold white'>Location</p>
                                        <div className='flex PDEmargin3'>
                                            <img alt='icon' src={location} className="PDEicon2"></img>
                                            <p className='small white'>{detail.tempat}</p>
                                        </div>
                                    </div>
                                </div>
                                <p className='semibig white bold PDEmargin'>Menu</p>
                                {
                                    detail.menu.map((post) => (
                                        <div className='PDEmenucard flex'>
                                            <div className='PDEmenukiri' style={{backgroundImage:`url(${post.foto})`}}/>
                                            <div className='PDEmenukanan'>
                                                <p className='semibig bold white'>{post.nama}</p>
                                                <p className='small white PDEmargin2'>This Set Menu Contains</p>
                                                <div className='flex PDEmargin2'>
                                                    {
                                                        post.bahan.map((x) => (
                                                            <div>
                                                                {
                                                                    x==="pork" && (
                                                                        <div className='flex' style={{flexDirection:"column"}}>
                                                                            <img alt="icon" src={pork} className="PDEicon"></img>
                                                                            <p className='tiny white' style={{textAlign:"center"}}>{x}</p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                
                            </div>
                            <div className='PDEkontenkanan desktop'>
                                <div className='PDEeventdate'>
                                    <p className='medium bold white'>Event date</p>
                                    <div className='PDEmargin2'>
                                        {
                                            detail.listEvent.map((post) => (
                                                <div className='PDEmargin3'>
                                                    <div className='flex' style={{alignItems:"center"}}>
                                                        <img alt='icon' src={calendar} className="PDEicon2"></img>
                                                        <p className='small white'>{post.tanggal} &ensp; • &ensp;  {post.jam}</p>
                                                    </div>
                                                    <div className='PDEslot'>
                                                        { post.sisa<=3 ? 
                                                        <p className='small red bold'>{post.sisa} Seats left</p>
                                                        :
                                                        <p className='small white bold'>{post.sisa} Seats left</p>
                                                        }
                                                        <p className='small white'>from {post.max}</p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>

                                <div className='PDElocation PDEmargin2'>
                                    <p className='medium bold white'>Location</p>
                                    <div className='flex PDEmargin3'>
                                        <img alt='icon' src={location} className="PDEicon2"></img>
                                        <p className='small white'>{detail.tempat}</p>
                                    </div>
                                </div>
                                <button onClick={() => handleJoinNow()} className='PDEbutton small bold PDEmargin2'>Join Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                </CSSTransition>
            }
        </div>
    )
  }